import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";

const faqs = [
  {
    question: "What is a Crypto currency investment?",
    answer:
      "Crypto currency investment involves putting your money into digital assets such as Bitcoin, Ethereum, and others, with the expectation of future gains.",
  },
  {
    question: "How do I invest with Capital Nest Investors?",
    answer:
      "To invest with Capital Nest Investors, simply sign up, verify your account, and select from available investment packages tailored to your risk level.",
  },
  {
    question: "What Edge does investing in crypto give you as an investor?",
    answer:
      "Crypto investments can offer higher returns, decentralization, and greater control over assets compared to traditional financial markets.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="md:min-h-screen py-20   px-6 md:px-20 text-white bg-[radial-gradient(26.31%_42.26%_at_50%_45.29%,#07031C_18.93%,#150F31_57.55%,#241D49_100%)]">
      <h2 className="text-[28px] md:text-[36px] text-[#F2C493] font-bold mb-10 font-lato">
        Frequently Asked Questions
      </h2>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* FAQ block */}
        <div className="flex flex-col space-y-4 max-w-3xl flex-1">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className={`flex flex-col rounded-xl transition-all duration-300 ${
                  isOpen
                    ? "bg-[#3E3850]/80 shadow-[0px_0px_120px_20px_rgba(0,0,0,0.3)]"
                    : ""
                }`}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className={`w-full flex justify-between items-center text-left px-6 py-4 text-[#D4F5F9] font-semibold text-[18px] md:text-[20px] ${
                    isOpen ? "" : "hover:bg-white/5 transition"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 rounded-md bg-[#D4F5F9]"></div>
                    <span>{faq.question}</span>
                  </div>

                  <div className="w-6 h-6 rounded-full bg-[#F2C493] flex items-center justify-center text-[#D4F5F9] font-bold">
                    {isOpen ? <FaMinus size={12} /> : <FaPlus size={12} />}
                  </div>
                </button>

                {isOpen && (
                  <div className="px-12 pb-4 text-[#C9D6F1] text-[15px] leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* New Side Box */}
        <div
          className="w-full lg:w-[420px] h-[154px] rounded-[15px] hidden md:flex items-center justify-center text-black text-center font-semibold text-[18px] px-[100px] py-6"
          style={{
            background:
              "linear-gradient(93.28deg, #DFBD69 15.17%, #926F34 73.42%)",
            gap: "19px",
          }}
        >
          <p></p>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
